<template>
  <div style="background-color: white;min-height: 650px;padding: 20px;box-sizing: border-box;">
    <div class="product-content">
      <img class="product-logo" :src="project_info.project_logo">
      <div class="middle-content">
        <p class="product_name" style="font-size: 14px;margin-bottom: 4px">{{ project_info.project_ename }}</p>
        <div style="display: flex;gap:5px;">
          <div v-if="showInstitutionRegistrationFee" class="price-container">
            <div>
              <p class="font_red font_bold">Institution Registration / License Fee</p>
              <p class="price-date">Institution payment configured for this program</p>
            </div>
            <p class="price">Fee: {{ formatProgramMoney(project_info.institution_price) }}</p>
          </div>
          <div v-if="!showInstitutionRegistrationFee && project_info.earlybird_deadline_date" class="price-container">
            <div>
              <p class="font_red font_bold">Early Bird Registration</p>
              <p class="price-date">DDL: {{ $dayjs(project_info.earlybird_deadline_date).format("MMMM DD,YYYY") }}</p>
            </div>
            <p class="price">Fee: {{ project_info.project_earlybird_price }} {{
              project_info.project_price_currency + 'per' + project_info.project_target_type}}</p>
          </div>
          <div v-if="!showInstitutionRegistrationFee" class="price-container">
            <div>
              <p class="font_red font_bold">Normal Registration</p>
              <p class="price-date">DDL: {{ $dayjs(project_info.deadline_date).format("MMMM DD, YYYY") }}</p>
            </div>
            <p class="price">Fee: {{ project_info.project_price == 0 ? 'Free' : project_info.project_price + ' ' +
              project_info.project_price_currency + 'per' + project_info.project_target_type}}</p>
          </div>
          <div v-if="!showInstitutionRegistrationFee && project_info.project_price !== 0" class="price-container">
            <div>
              <p class="font_red font_bold">Fee Reduction</p>
            </div>
            <p class="price-reduction font_red">
                <span v-if="reduction_level8 === 0">Not Available</span>
                
                <span v-else @click="showFeeReduction" class="font_under_line" style="font-family: centurygothic;">
                    {{
                    `${reduction_level1} to ${reduction_level8} ${project_info.project_price_currency}`
                }}
                <i class="el-icon-info" 
                    style="color: #909399; cursor: pointer; font-size: 14px;"
                    @click="showFeeReduction">
                </i>
                </span>
                    
                
            </p>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div  v-if="project_info.project_need_qualification && project_info.project_need_qualification == 'YES'">    
            <p style="font-size: 16px;display: inline-block;margin-right: 10px;">This program requires qualification <br>and it does not allow open registration</p>
            
        </div>
        <div v-else>
          <div
            class="btn-sign"
            v-if="checkSignStatus()"
            :class="{ 'btn-disabled': isSignUpButtonDisabled() }"
            @click="showSignUpDialog">
            {{ getSignUpButtonLabel() }}
          </div>
          <div class="btn-disabled" v-if="checkClosed()">Closed</div>
        </div>
      </div>
    </div>
    <div style="margin-top: 30px;">
      <el-row :gutter="20">
        <el-col :span="16">
          <div>
            <p class="title">Introduction</p>
            <p v-html="project_info.project_introduction" class="intro_container ql-snow ql-editor"></p>
          </div>
        </el-col>
        <el-col :span="8">
          <div>
            <p class="title">Announcements & Updates</p>
            <div class="announce-container">
              <div v-for="(announce, index) in news" :key="index" class="announce-item"
                @click="doShowNewsInfo(announce)">
                <p class="announce-time">{{ $dayjs(announce.update_time * 1000).format('MMM D, YYYY') }}</p>
                <p class="announce-title">{{ announce.post_title }}</p>
                <p class="announce-content" v-html="announce.post_content"></p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- <el-dialog :visible.sync="isShowDialog" title="View" width="80%">
      <div class="disable-mouse-events">
        <iframe :src="price_policy + '#toolbar=0'" width="100%" height="600px"></iframe>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="isShowSignUpDialog" :title="getSignUpDialogTitle()" width="800px"
      @close="closeDialog">
      <div>
        <el-form :inline="true" ref="form" class="signup-arrangement-form">
          <el-form-item label="Select program advisor(s)">
            <el-select v-model="selectContactIds" placeholder="Please select" :multiple="true" filterable style="width: 400px;">
              <el-option v-for="(contact, index) in teacherOpt" :key="getContactId(contact) || index" :label="formatContactName(contact)"
                :value="getContactId(contact)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Participation arrangement">
            <el-select v-model="participationArrangement" placeholder="Please select" style="width: 400px;">
              <el-option
                :label="getParticipationArrangementLabel('Standard registration')"
                value="Standard registration">
              </el-option>
              <el-option
                :label="getParticipationArrangementLabel('School day')"
                value="School day"
                :disabled="!isSchoolDayAvailable()">
              </el-option>
            </el-select>
            <p class="arrangement-help">{{ getParticipationArrangementHelpText() }}</p>
          </el-form-item>
          <p>*Emails to students for the project will also go to the assigned program advisor.</p>
        </el-form>
        <div v-if="participationArrangement === 'School day'" class="institution-terms-panel">
          <p class="institution-terms-title">Institution Terms & Conditions / Refund Policy</p>
          <div class="institution-terms-content ql-snow ql-editor" v-html="getInstitutionTermsPolicy()"></div>
          <div class="terms-confirm-row">
            <el-checkbox v-model="isInstitutionTermsAgree">
              I have read and agree to the institution terms and conditions, including the refund policy.
            </el-checkbox>
          </div>
        </div>
        <div style="width: 100%; text-align: center; margin-top: 30px">
          <el-button size="medium" @click="isShowSignUpDialog = false">Cancel</el-button>
          <el-button type="primary" size="medium" @click="saveInfo(formData)">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowDialog" title="Fee Reduction Policy" width="65%" :modal="true" :show-close="false" :modal-append-to-body="true" custom-class="showCustomEAEPolicyDialogStyle">
            <div>
                <EAE_Fee_Reduction_Policy :price_reductions="project_info.price_reductions"></EAE_Fee_Reduction_Policy>
            </div>
        </el-dialog>
    <el-dialog :visible.sync="showNewsDialog" width="45%" :title="selectNews.title">
      <div style="margin: 10px">
        <p v-html="selectNews.content" style="color: #666;font-size: 14px;line-height: 20px;"></p>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  updateAccountApplicationContacts,
  getNewsUpdateListByProject,
  getAccountReductionLevelByProject,
  getREProjectInfo,
  checkAccountApplication,
  addAccountApplication,
  getContactsByAccount,
  checkAccountEligibility,
  getPulsesByTagsAndUsers,
  getSchoolRegistrations,
  getContactInfo,
} from '../../api/eae'
import {
  getUserId,
  getUserType,
  getAccountId,
  getUserName,
} from '../../utils/store'
import '../../assets/common/font.css'
import EAE_Fee_Reduction_Policy from '../../components/EAE_Fee_Reduction_Policy.vue';
export default ({
  name: 'index',
  components: {
        EAE_Fee_Reduction_Policy
    },
  data() {
    return {
      user_type: getUserType(),
      project_id: this.$route.query.project_id,
      from: this.$route.query.from,
      project_info: {},
      productPrice: {},
      reduction_level: 0,
      reduction_level1: 0,
      reduction_level8: 0,
      reduction_price: 0,
      price_policy: '',
      news: [],
      checkAccount: null,
      isShowDialog: false,
      isShowSignUpDialog: false,
      teacherOpt: [],
      showNewsDialog: false,
      selectNews: {},
      selectContactIds: [],
      participationArrangement: '',
      isInstitutionTermsAgree: false,
      existingApplication: null
    }
  },
  mounted() {
    this.fetchData()
    this.getSubjectList()
  },
  computed: {
    showInstitutionRegistrationFee() {
      return this.project_info
        && this.project_info.institution_payment_enabled === 'YES'
        && Number(this.project_info.institution_price || 0) > 0
    }
  },
  methods: {

    formatContactName(contact) {
      if (!contact) return ''
      const capitalizeWords = str => String(str || '').split(' ')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');

      if (contact.contact_enName) {
        return capitalizeWords(contact.contact_enName);
      }
      
      const lastName = capitalizeWords(contact.contact_lastName);
      const givenName = capitalizeWords(contact.contact_givenName);
      const fullName = `${lastName} ${givenName}`.trim()
      if (fullName) return fullName
      return contact.contact_email || this.getContactId(contact) || ''
    },
    getContactId(contact) {
      if (!contact) return ''
      if (typeof contact._id === 'string') return contact._id
      if (contact._id && contact._id.$id) return contact._id.$id
      if (typeof contact.id === 'string') return contact.id
      return ''
    },
    async ensureSelectedAdvisorOptions(ids) {
      const selectedIds = (ids || []).filter(Boolean)
      if (selectedIds.length === 0) return
      const existingIds = new Set(this.teacherOpt.map(contact => this.getContactId(contact)).filter(Boolean))
      const missingIds = selectedIds.filter(id => !existingIds.has(id))
      for (const contactId of missingIds) {
        let contact = null
        try {
          const res = await getContactInfo(contactId)
          const payload = res && res.data ? res.data : null
          if (payload && payload.code === 0 && payload.data) {
            contact = payload.data
          } else if (payload && (payload.contact_email || payload.contact_enName || payload.contact_lastName || payload._id)) {
            contact = payload
          }
        } catch (e) {
          contact = null
        }
        if (!contact || !this.getContactId(contact)) {
          contact = {
            _id: { $id: contactId },
            contact_enName: contactId === getUserId()
              ? (getUserName() || 'Current advisor')
              : ''
          }
        }
        if (!this.formatContactName(contact)) {
          contact.contact_enName = contactId === getUserId()
            ? (getUserName() || 'Current advisor')
            : ('Advisor ' + String(contactId).slice(-6))
        }
        this.teacherOpt.push(contact)
        existingIds.add(contactId)
      }
    },

    needsParticipationArrangement() {
      return !!(this.project_info && this.project_info.institution_payment_enabled === 'YES')
    },
    isSignUpButtonDisabled() {
      // Already signed up: only keep clickable when institution payment needs arrangement selection/update
      return this.checkAccount == 0 && !this.needsParticipationArrangement()
    },
    getSignUpButtonLabel() {
      if (this.checkAccount != 0) {
        return 'Sign Up'
      }
      return this.needsParticipationArrangement() ? 'Update Arrangement' : 'Signed Up'
    },
    getSignUpDialogTitle() {
      const name = this.project_info && this.project_info.project_ename ? this.project_info.project_ename : 'Program'
      if (this.checkAccount == 0 && this.needsParticipationArrangement()) {
        return 'Update participation for ' + name
      }
      return 'Sign Up for ' + name
    },

    checkSignStatus() {
      if (this.project_info.deadline_date && this.project_info.deadline_date != '') {
        let deadline_date = this.project_info.deadline_date + (23 * 60 * 60 + 59 * 60 + 59) * 1000
        let current_time = new Date().getTime()
        if (deadline_date > current_time) {
          return true
        }
      }
      return false
    },
    checkClosed() {
      if (this.project_info.deadline_date && this.project_info.deadline_date != '') {
        let deadline_date = this.project_info.deadline_date + (23 * 60 * 60 + 59 * 60 + 59) * 1000
        let current_time = new Date().getTime()
        if (deadline_date <= current_time) {
          return true
        }
      }
      return false
    },

    getSubjectList() {
      this.teacherOpt = []
      return getContactsByAccount(getAccountId()).then((res) => {
        const rows = Array.isArray(res.data) ? res.data : []
        this.teacherOpt = rows.filter(contact => !!this.getContactId(contact))
      }).catch((err) => {
        console.error('Failed to load advisors:', err)
        this.teacherOpt = []
      })
    },
    async fetchData() {

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      let projectResult = await getREProjectInfo(this.project_id)
      this.project_info = projectResult.data

      // Use the new API with project_code as tag
      const user_ids = [
        '6743d93894c7841b468b456d',
        '68b11ba594c784d9568b4596',
        '68b11bcc94c784da568b458f',
        '68b11c6894c784d6568b458f',
        '68b11c2694c78460328b4571',
        '68b11d7c94c784d4568b4586',
        '68b11b7894c784da568b458e',
        '68b11b4194c784d6568b458e'
      ]
      
      const project_code = this.project_info.project_code || ''
      if (project_code) {
        try {
          let newsResult = await getPulsesByTagsAndUsers(user_ids, project_code, 50, 0)
          if (newsResult.data && newsResult.data.code === 0 && newsResult.data.data) {
            this.news = newsResult.data.data.map(pulse => this.formatPulseData(pulse)).sort((a, b) => {
              const timeA = a.display_date || a.created_at || 0
              const timeB = b.display_date || b.created_at || 0
              return timeB - timeA
            })
          } else {
            this.news = []
          }
        } catch (error) {
          console.error('Failed to fetch news:', error)
          this.news = []
        }
      } else {
        this.news = []
      }
      let reductionLevelResult = await getAccountReductionLevelByProject(getAccountId())
      let reduction_level = reductionLevelResult.data

      await checkAccountApplication(getAccountId(), this.project_id).then((res) => {
        this.checkAccount = res.data.code
      })
      await this.loadExistingApplication()

      for (let i = 0; i < this.project_info.price_reductions.length; i++) {
        let price = this.project_info.price_reductions[i]
        if (price.level == reduction_level) {
          this.reduction_price = price.reduction_price
          break
        }
      }
      this.reduction_level1 = this.project_info.price_reductions[0].reduction_price
      this.reduction_level8 = this.project_info.price_reductions[7].reduction_price
      this.price_policy = this.project_info.price_policy

      loading.close()
    },

    async loadExistingApplication() {
      this.existingApplication = null
      if (this.checkAccount != 0) {
        return
      }
      const targetType = this.project_info && this.project_info.project_target_type
        ? String(this.project_info.project_target_type).toLowerCase()
        : 'student'
      try {
        const res = await getSchoolRegistrations(getAccountId(), targetType === 'school' ? 'school' : 'student')
        const rows = Array.isArray(res.data) ? res.data : []
        this.existingApplication = rows.find((row) => {
          const rowProjectId = row.project_id || (row.project && row.project._id && row.project._id.$id)
          return rowProjectId === this.project_id
        }) || null
      } catch (e) {
        console.error('Failed to load existing application:', e)
        this.existingApplication = null
      }
    },

    async showSignUpDialog() {
      if (this.isSignUpButtonDisabled()) {
        return
      }

      this.participationArrangement = (this.existingApplication && this.existingApplication.participation_arrangement)
        ? this.existingApplication.participation_arrangement
        : ''
      this.isInstitutionTermsAgree = false

      //如果是advisor登录，点击创建报名表，然后把当前老师设置为项目负责人
      if (this.user_type == 'advisor') {
        if (this.existingApplication && Array.isArray(this.existingApplication.application_contacts) && this.existingApplication.application_contacts.length > 0) {
          this.selectContactIds = [...this.existingApplication.application_contacts]
          if (this.selectContactIds.indexOf(getUserId()) === -1) {
            this.selectContactIds.push(getUserId())
          }
        } else {
          this.selectContactIds = [getUserId()]
        }
        await this.ensureSelectedAdvisorOptions(this.selectContactIds)
        this.isShowSignUpDialog = true
        return
      }

      if (this.existingApplication && Array.isArray(this.existingApplication.application_contacts)) {
        this.selectContactIds = [...this.existingApplication.application_contacts]
      } else {
        this.selectContactIds = []
      }
      await this.ensureSelectedAdvisorOptions(this.selectContactIds)
      this.isShowSignUpDialog = true
    },

    closeDialog() {
    },
  getLocalBrowserTimeString() {
      const now = new Date();
      const pad = (n) => (n < 10 ? '0' + n : '' + n);
      const year = now.getFullYear();
      const month = pad(now.getMonth() + 1);
      const day = pad(now.getDate());
      const hours = pad(now.getHours());
      const minutes = pad(now.getMinutes());
      const seconds = pad(now.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  },
    saveInfo() {
      if (this.selectContactIds.length <= 0) {
        this.$message.warning('Please select advisors')
        return
      }

      let arrangement = this.participationArrangement
      if (!arrangement) {
        this.$message.warning('Please select participation arrangement')
        return
      }
      if (arrangement === 'School day' && !this.isSchoolDayAvailable()) {
        this.$message.warning('School day is not available for this program')
        return
      }
      if (arrangement === 'School day' && !this.isInstitutionTermsAgree) {
        this.$message.warning('Please read and agree to the institution terms and conditions')
        return
      }

      const accountId = getAccountId()
      const localTime = this.getLocalBrowserTimeString()
      const newContacts = this.selectContactIds
      let contact_id = ''
      if (this.user_type == 'advisor') {
        contact_id = getUserId()
      }

      checkAccountEligibility(accountId, this.project_id, localTime).then((res) => {
        const result = res.data || {}
        const data = result.data || {}

        const hasErrors = Array.isArray(data.errors) && data.errors.length > 0
        const isEligible = !!data.eligible && !hasErrors && result.code === 0

        if (isEligible) {
          addAccountApplication(accountId, this.project_id, contact_id, {
            participation_arrangement: arrangement,
            institution_terms_agreed: arrangement === 'School day' ? 'YES' : 'NO',
            institution_terms_agreed_user_id: getUserId()
          }).then((res) => {
            let result = res.data
            if (result.code == 0) {
              this.saveAppContacts(result.data._id.$id, newContacts)
            } else {
              this.$message.warning(result.msg)
            }
          })
        } else {
          const errors = Array.isArray(data.errors) ? data.errors : []
          const warnings = Array.isArray(data.warnings) ? data.warnings : []
          const messages = [...errors, ...warnings]
          const messageText = messages.length ? messages.join('<br>') : (result.msg || 'Your account is not eligible for this project.')

          this.$alert(messageText, 'Not Eligible', {
            type: 'warning',
            confirmButtonText: 'OK',
            dangerouslyUseHTMLString: true
          }).catch(() => {
            // dialog closed
          })
        }
      }).catch(() => {
        this.$message.error('Failed to check eligibility. Please try again later.')
      })
    },
    saveAppContacts(application_id, contacts) {
      updateAccountApplicationContacts(application_id, contacts).then((res) => {
        this.$message.success(this.checkAccount == 0 ? 'Arrangement updated.' : 'Sign-up successful.')
        this.isShowSignUpDialog = false
        this.fetchData()
      })
    },
    isSchoolDayAvailable() {
      const enabled = this.project_info && this.project_info.institution_payment_enabled === 'YES'
      const price = Number(this.project_info && this.project_info.institution_price ? this.project_info.institution_price : 0)
      return enabled && price > 0
    },
    getParticipationArrangementLabel(value) {
      const labels = {
        'School day': 'School-branded Event With Authorization',
        'Standard registration': 'Student Independent Registration Coordinated by School'
      }
      return labels[value] || value
    },
    getParticipationArrangementHelpText() {
      // Keep copy identical to the official AM institution registration form
      if (this.participationArrangement === 'Standard registration') {
        return 'Students register and pay individually. Your school is not invoiced, and students take part in the official competition window.'
      }
      if (this.participationArrangement === 'School day') {
        return 'Your school coordinates participation and pays on behalf of its students, and runs the marathon at a date and time of its choosing.'
      }
      if (!this.isSchoolDayAvailable()) {
        return 'School day is available only when institution payment is enabled and an institution net price is configured for this project.'
      }
      return 'Choose whether students register individually or your school runs a school day with institution payment.'
    },
    getInstitutionTermsPolicy() {
      const policy = this.project_info && this.project_info.institution_terms_policy
        ? String(this.project_info.institution_terms_policy)
        : ''
      if (policy.trim() !== '') {
        return policy.replaceAll('\r\n\r\n', '<br><br>')
      }
      return [
        '<p>By submitting this institution registration, the account advisor confirms that they are authorized to register the institution for this program and to coordinate payment with the institution.</p>',
        '<p><span class="tag">Draft — pending legal sign-off</span></p>',
        '<p>The institution registration/license fee is charged once per institution, per program, per competition year.</p>',
        '<p>The license covers students who register through the institution paid registration link.</p>',
        '<p>The license is activated only after the full fee is received in the beneficiary account.</p>',
        '<p>Where payment is made by international wire, all bank charges must be borne by the payer (OUR). Any shortfall remains payable before activation.</p>',
        '<p><strong>Refunds</strong></p>',
        '<ol><li><strong>Full refund</strong> if requested at least <strong>30 days</strong> before the program official start date, and no student has yet registered through your institution link.</li><li><strong>50% refund</strong> if requested at least <strong>14 days</strong> before the official start date, and no student has yet registered through your institution link.</li><li><strong>No refund</strong> within 14 days of the official start date, once any student has registered through your institution link, or once the program has begun.</li><li><strong>Unused places are not refunded or carried forward.</strong> Where your institution purchased a fixed number of places, places left unused, including after a student is removed from the roster, are not refundable.</li><li><strong>Payment processing fees and bank charges are not refundable.</strong> Card payments are refunded to the original card; bank transfers are refunded by bank transfer to the payer.</li><li><strong>If we cancel or materially change the program, the fee is refunded in full.</strong></li></ol>',
        '<p>Submission of payment constitutes acceptance of the EAE Integrity Policy and the program rules.</p>'
      ].join('')
    },
    formatProgramMoney(amount) {
      const currency = this.project_info && this.project_info.project_price_currency
        ? this.project_info.project_price_currency
        : 'USD'
      return currency + ' ' + Number(amount || 0).toFixed(2)
    },
    goBack() {
      this.$router.go(-1)
    },

    showFeeReduction() {
      console.log('showFeeReduction',this.price_policy)
      if(this.project_info.price_reductions && this.project_info.price_reductions >=8 ){
          this.isShowDialog = true
      }
      // if (this.price_policy) {
      this.isShowDialog = true
    },
    renderMarkdown(content) {
      if (!content) return '';
      
      // Simple markdown to HTML conversion
      let html = content
        // Headers
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        // Bold
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/__([^_]+)__/g, '<strong>$1</strong>')
        // Italic
        .replace(/\*([^*]+)\*/g, '<em>$1</em>')
        .replace(/_([^_]+)_/g, '<em>$1</em>')
        // Links
        .replace(/\[([^\]]+)\]\(([^\)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
        // Code blocks
        .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
        // Inline code
        .replace(/`([^`]+)`/g, '<code>$1</code>')
        // Line breaks
        .replace(/\n/g, '<br>');
      
      return html;
    },
    formatPulseData(pulse) {
      // Extract title from content (first line or H1)
      let title = ''
      let content = pulse.content || ''
      
      // Try to extract H1 title
      const h1Match = content.match(/^#\s+(.+)$/m)
      if (h1Match) {
        title = h1Match[1].trim()
        // Remove H1 from content
        content = content.replace(/^#\s+.+$/m, '').trim()
      } else {
        // Use first line as title
        const firstLine = content.split('\n')[0].trim()
        if (firstLine && firstLine.length < 100) {
          title = firstLine.replace(/^#+\s*/, '').trim()
          content = content.substring(firstLine.length).trim()
        } else {
          title = 'Announcement'
        }
      }
      
      // Use display_date if available, otherwise created_at
      const timestamp = pulse.display_date || pulse.created_at || 0
      
      // Render markdown to HTML
      const renderedContent = this.renderMarkdown(content)
      
      return {
        update_time: timestamp,
        post_title: title,
        post_content: renderedContent,
        title: title,
        content: renderedContent,
        display_date: pulse.display_date,
        created_at: pulse.created_at,
      }
    },
    doShowNewsInfo(news) {
      this.selectNews = news
      this.showNewsDialog = true
    },
  }
})
</script>
<style scoped lang="scss">
.product-content {
  margin-top: 20px;
  width: 100%;
  border: 1px solid #E6D7D7;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 16px;
  display: flex;

  .product-logo {
    width: 80px;
    height: 80px;
    object-fit: cover;
  }

  .middle-content {
    padding: 0px 10px;
    box-sizing: border-box;
    font-size: 14px;

    .price-container {
      border-radius: 5px;
      padding: 6px 10px;
      //box-sizing: border-box;
      background: #F8F8F8;

      .price-date {
        font-family: centurygothic;
      }

      .price {
        font-family: centurygothic;
      }

      .price-reduction {
        margin-top: 10px;
        font-family: centurygothic;
      }

    }


  }

  .right-content {
    flex: 1;
    text-align: right;
    padding: 0px 10px;
    box-sizing: border-box;

    .btn-sign {
      display: inline-block;
      padding: 12px 0;
      width: 110px;
      text-align: center;
      background-color: #ff6450;
      border-radius: 5px;
      box-sizing: border-box;
      color: white;
      font-size: 15px;
      cursor: pointer;
    }

    .desc {
      margin-top: 10px;
      color: #4A0700;
      font-size: 14px;
      font-family: centurygothic;
      line-height: 20px;
    }

    .btn-disabled {
      border-radius: 5px;
      box-sizing: border-box;
      display: inline-block;
      color: #999;
      padding: 4px 12px;
      background-color: #e2e2e2;
      border: 1px solid #e2e2e2;
    }
  }
}


.product_name {
  margin-left: 10px;
  color: #333;
  font-size: 20px;
  font-family: centurygothic_bold;
}

.title {
  color: #333;
  font-size: 16px;
  font-family: centurygothic_bold;
  margin-bottom: 15px;
}

.intro_container {
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid #F0E1E1;
  font-size: 14px;
  color: #333;
  line-height: 22px;
  padding: 20px 20px;
  font-family: centurygothic;
}

.institution-terms-panel {
  margin-top: 18px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  padding: 16px;
  text-align: left;
}

.institution-terms-title {
  color: #333;
  font-size: 15px;
  font-family: centurygothic_bold;
  margin-bottom: 10px;
}

.institution-terms-content {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  color: #606266;
  font-size: 14px;
  line-height: 22px;
  padding: 12px;
}

.institution-terms-content .tag {
  display: inline-block;
  background: #faeeda;
  border: 1px solid #fac775;
  border-radius: 4px;
  color: #854f0b;
  font-size: 12px;
  padding: 2px 8px;
}

.terms-confirm-row {
  margin-top: 12px;
}


.announce-container {
  width: 100%;

  .announce-item {
    cursor: pointer;
    background-color: #F8F8F8;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 20px;
    margin-bottom: 20px;

    .announce-time {
      color: var(--c-primary);
      font-size: 14px;
      font-family: centurygothic_bold;
    }

    .announce-title {
      margin-top: 20px;
      color: #333;
      font-size: 14px;
      font-family: centurygothic_bold;
    }

    .announce-content {
      margin-top: 10px;
      color: #999;
      font-size: 12px;
      line-height: 18px;
      font-family: centurygothic;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      /* 定义显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

}

.font_bold {
  font-weight: bold;
}

.font_red {
  color: var(--c-primary);
}

.font_under_line {
  text-decoration: underline 1px solid var(--c-primary);
  cursor: pointer;
}

.arrangement-help {
  width: 400px;
  max-width: 100%;
  color: #666;
  font-size: 12px;
  line-height: 16px;
  margin-top: 10px;
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: none;
  white-space: normal;
}

.signup-arrangement-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
